/* eslint-disable */
import React, { Component } from 'react'

class LinuxFoundationLogo extends Component {
  static defaultProps = {
    st0ColorName: 'footer__linuxfoundation-st0',
    st1ColorName: 'footer__linuxfoundation-st1',
    height: 26.9,
    width: 489.1,
  }

  render() {
    const { st0ColorName, st1ColorName, height, width } = this.props

    var style = {
      enableBackground: `new 0 0 ${width} ${height}`,
    };

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={`${width}px`}
        height={`${height}px`}
        viewBox={`0 0 ${width} ${height}`}
        style={style}
      >
        <title>linuxfoundation-logo</title>
        <g>
          <g>
            <path className={st0ColorName} d="M25.6,0.4h16.2v1.7h-7.1v18.7h-1.9V2.1h-7.1V0.4z"/>
            <path className={st0ColorName} d="M43.7,0.4h1.9v8.8h12.1V0.4h1.9v20.4h-1.9v-9.9H45.7v9.9h-1.9V0.4z"/>
            <path className={st0ColorName} d="M63.8,0.4h14.1v1.7H65.7v7.4h11.4v1.7H65.7v8H78v1.7H63.8V0.4z"/>
          </g>
          <g>
            <polygon className={st1ColorName} points="4.1,16.7 4.1,8.6 0,8.6 0,20.8 12.2,20.8 12.2,16.7     "/>
            <polygon className={st0ColorName} points="20.4,0.4 0,0.4 0,6.5 4.1,6.5 4.1,4.5 16.3,4.5 16.3,16.7 14.3,16.7 14.3,20.8 20.4,20.8     "/>
          </g>
          <g>
            <path className={st0ColorName} d="M185.7,0.4h12.9v1.7h-11v7.4h9.8v1.7h-9.8v9.7h-1.9V0.4z"/>
            <path className={st0ColorName} d="M209.5,0c6.4,0,9.6,5,9.6,10.6c0,5.6-3.2,10.6-9.6,10.6c-6.4,0-9.6-5-9.6-10.6C199.9,5,203.1,0,209.5,0z
               M209.5,19.6c5.4,0,7.6-4.5,7.6-9c0-4.5-2.3-9-7.6-9c-5.4,0-7.7,4.5-7.7,9C201.9,15.1,204.1,19.6,209.5,19.6z"/>
            <path className={st0ColorName} d="M221.9,0.4h1.9V13c0,4.7,2.2,6.5,6,6.5c3.8,0,6-1.8,6-6.5V0.4h1.9v13c0,4.2-2.3,7.8-7.9,7.8
              c-5.6,0-7.9-3.6-7.9-7.8V0.4z"/>
            <path className={st0ColorName} d="M241.7,0.4h2.2l11.9,17.2h0.1V0.4h1.9v20.4h-2.2L243.7,3.6h-0.1v17.2h-1.9V0.4z"/>
            <path className={st0ColorName} d="M261.8,0.4h7c6.2,0.1,9.4,3.5,9.4,10.2c0,6.7-3.2,10-9.4,10.2h-7V0.4z M263.7,19.1h4.1c5.9,0,8.4-2.4,8.4-8.5
              s-2.5-8.5-8.4-8.5h-4.1V19.1z"/>
            <path className={st0ColorName} d="M287.3,0.4h2.2l8,20.4h-2.1l-2.5-6.3h-9.3l-2.5,6.3h-2.1L287.3,0.4z M284.2,12.8h8l-3.9-10.4L284.2,12.8z"/>
            <path className={st0ColorName} d="M295.2,0.4h16.2v1.7h-7.1v18.7h-1.9V2.1h-7.1V0.4z"/>
            <path className={st0ColorName} d="M313.4,0.4h1.9v20.4h-1.9V0.4z"/>
            <path className={st0ColorName} d="M328.1,0c6.4,0,9.6,5,9.6,10.6c0,5.6-3.2,10.6-9.6,10.6c-6.4,0-9.6-5-9.6-10.6C318.5,5,321.7,0,328.1,0z
               M328.1,19.6c5.4,0,7.6-4.5,7.6-9c0-4.5-2.3-9-7.6-9c-5.4,0-7.7,4.5-7.7,9C320.5,15.1,322.7,19.6,328.1,19.6z"/>
            <path className={st0ColorName} d="M340.7,0.4h2.2l11.9,17.2h0.1V0.4h1.9v20.4h-2.2L342.7,3.6h-0.1v17.2h-1.9V0.4z"/>
          </g>
          <g>
            <path className={st0ColorName} d="M83.4,0.4h6.3v15.1h9v5.2H83.4V0.4z"/>
            <path className={st0ColorName} d="M102.7,0.4h6.3v20.3h-6.3V0.4z"/>
            <path className={st0ColorName} d="M113.6,0.4h6.4l5.9,10.9h0.1V0.4h5.9v20.3h-6.1l-6.2-11.1h-0.1v11.1h-5.9V0.4z"/>
            <path className={st0ColorName} d="M155,12.9c0,5.7-3,8.3-9.2,8.3c-6.3,0-9.3-2.7-9.3-8.3V0.4h6.3v11.1c0,2,0,4.7,3,4.7c3,0,3-2.6,3-4.7V0.4h6.3
              V12.9z"/>
            <path className={st0ColorName} d="M164.9,9.9l-6.7-9.5h7.3l3.1,5.5l3-5.5h6.9l-6.5,9.5l7.2,10.7h-7.5l-3.5-6.1l-3.6,6.1h-7.2L164.9,9.9z"/>
          </g>
          <g>
            <path className={st1ColorName} d="M363.6,0.7h5.6c2.1,0,3.8,0.5,4.9,1.4c1.1,1,1.7,2.3,1.7,3.9c0,1.7-0.6,3-1.7,4c-1.1,1-2.8,1.5-5.1,1.5h-3.9
              V21h-1.6V0.7z M365.2,2v8.2h3.8c1.7,0,3-0.4,3.9-1.1c0.9-0.7,1.3-1.7,1.3-3c0-1.3-0.4-2.2-1.3-3C372,2.4,370.8,2,369.2,2H365.2z"
              />
            <path className={st1ColorName} d="M378.9,0.7h5.2c2.2,0,3.9,0.5,5,1.4c1.2,0.9,1.7,2.2,1.7,3.8c0,2.3-1.3,4-3.9,4.9c0.7,0.3,1.6,1.4,2.7,3.1
              l4.6,7h-1.9l-3.5-5.6c-1.2-1.9-2.1-3-2.8-3.5c-0.7-0.5-1.6-0.7-2.9-0.7h-2.7V21h-1.6V0.7z M380.4,2v8h3.4c1.7,0,3-0.3,3.9-1
              c0.9-0.7,1.4-1.7,1.4-2.9c0-1.3-0.5-2.2-1.4-2.9c-0.9-0.7-2.2-1-4-1H380.4z"/>
            <path className={st1ColorName} d="M404.8,0.4c3,0,5.6,1,7.6,3c2.1,2,3.1,4.5,3.1,7.4c0,2.9-1,5.4-3.1,7.4s-4.6,3-7.6,3c-3,0-5.5-1-7.6-3
              c-2.1-2-3.1-4.5-3.1-7.4c0-2.9,1-5.4,3.1-7.4C399.3,1.4,401.8,0.4,404.8,0.4z M404.9,19.8c2.5,0,4.7-0.9,6.4-2.6
              c1.7-1.7,2.6-3.9,2.6-6.4c0-2.5-0.9-4.6-2.6-6.4c-1.7-1.7-3.9-2.6-6.4-2.6c-2.5,0-4.7,0.9-6.5,2.6c-1.8,1.7-2.6,3.9-2.6,6.4
              c0,2.5,0.9,4.6,2.6,6.4C400.2,19,402.3,19.8,404.9,19.8z"/>
            <path className={st1ColorName} d="M421.1,0.7V21c0,2.2-0.4,3.8-1.3,4.6c-0.8,0.9-1.8,1.3-3,1.3c-0.3,0-0.6,0-0.9-0.1l-0.1-1.5
              c0.3,0.1,0.6,0.1,0.9,0.1c1.9,0,2.9-1.4,2.9-4.1V0.7H421.1z"/>
            <path className={st1ColorName} d="M436.8,0.7V2h-9.5v8.1h9.3v1.3h-9.3v8.3h9.8V21h-11.3V0.7H436.8z"/>
            <path className={st1ColorName} d="M457.8,2.1v1.7c-2.5-1.3-4.9-2-7.2-2c-2.5,0-4.6,0.9-6.3,2.6c-1.7,1.7-2.5,3.9-2.5,6.4c0,2.6,0.9,4.7,2.6,6.4
              c1.7,1.7,3.9,2.5,6.5,2.5c2.2,0,4.6-0.7,7.2-2.1v1.6c-2.4,1.3-4.8,1.9-7.2,1.9c-3.1,0-5.7-1-7.7-3c-2.1-2-3.1-4.5-3.1-7.4
              c0-3,1.1-5.5,3.2-7.5c2.1-2,4.6-3,7.5-3C452.9,0.4,455.3,1,457.8,2.1z"/>
            <path className={st1ColorName} d="M476.2,0.7V2h-7.6v19H467V2h-7.6V0.7H476.2z"/>
            <path className={st1ColorName} d="M488.3,1.7v1.7c-1.8-1-3.3-1.6-4.6-1.6c-1.2,0-2.2,0.4-3.1,1.1c-0.8,0.7-1.2,1.7-1.2,2.8
              c0,0.8,0.2,1.5,0.7,2.1c0.5,0.6,1.5,1.2,3,1.8c1.5,0.6,2.7,1.1,3.4,1.5c0.7,0.4,1.3,1,1.8,1.7c0.5,0.7,0.7,1.7,0.7,2.9
              c0,1.6-0.6,2.9-1.7,4c-1.1,1.1-2.5,1.6-4.2,1.6c-1.7,0-3.4-0.6-5.2-1.8v-1.8c2,1.4,3.7,2.2,5.1,2.2c1.2,0,2.2-0.4,3-1.2
              c0.8-0.8,1.2-1.7,1.2-2.9c0-0.9-0.3-1.6-0.8-2.3c-0.5-0.7-1.6-1.3-3.1-1.9c-1.6-0.6-2.7-1.1-3.4-1.5c-0.7-0.4-1.2-0.9-1.7-1.6
              c-0.5-0.7-0.7-1.6-0.7-2.6c0-1.5,0.6-2.8,1.7-3.8c1.1-1.1,2.5-1.6,4.1-1.6C485.1,0.4,486.7,0.9,488.3,1.7z"/>
          </g>
        </g>
      </svg>

    )
  }
}

export default LinuxFoundationLogo
